import { create } from 'zustand'
import { GET } from 'shared/api/GET'
import { consoleError } from 'shared/helpers/consoleError'

const getInitialNotificationsStore = () => ({
  isUserListLoading: false,
  userList: []
})

export const useNotificationsStore = create<INotificationsStore>(set => ({
  ...getInitialNotificationsStore(),
  loadUserList: async () => {
    set(state => {
      return {
        ...state,
        isUserListLoading: true
      }
    })
    try {
      const userList = await GET.userList()
      set(state => {
        return {
          ...state,
          userList
        }
      })
    } catch (error) {
      consoleError(error)
    } finally {
      set(state => {
        return {
          ...state,
          isUserListLoading: false
        }
      })
    }
  }
}))

export type UserType = {
  customerName: string
  deviceToken: string
  phoneNumber: string
  companyId: string
  recordTTL: number
}

export interface INotificationsStore {
  isUserListLoading: boolean
  loadUserList: () => void
  userList: UserType[]
}
